import { Vector3 } from '@babylonjs/core';

import type { OctreeGeometryNode } from './OctreeGeometryNode';
import type { NodeLoader, Metadata } from './OctreeLoader';
import type { PointAttributes } from './PointAttributes';

export class BoundingBox {
  constructor(public minimumWorld: Vector3, public maximumWorld: Vector3) {}

  clone(): BoundingBox {
    return new BoundingBox(
      this.minimumWorld.clone(),
      this.maximumWorld.clone(),
    );
  }

  get min(): Vector3 {
    return this.minimumWorld;
  }

  get max(): Vector3 {
    return this.maximumWorld;
  }

  get centerWorld(): Vector3 {
    return new Vector3(
      (this.minimumWorld.x + this.maximumWorld.x) / 2,
      (this.minimumWorld.y + this.maximumWorld.y) / 2,
      (this.minimumWorld.z + this.maximumWorld.z) / 2,
    );
  }

  get extendSizeWorld(): Vector3 {
    return this.maximumWorld.subtract(this.minimumWorld);
  }

  getBoundingSphere(sphere: Sphere): Sphere {
    const center = this.centerWorld;
    const extent = this.extendSizeWorld;
    const radius = extent.length() / 2;

    sphere.center = center;
    sphere.radius = radius;

    return sphere;
  }
}

export class Sphere {
  constructor(
    public center: Vector3 = new Vector3(),
    public radius: number = 0,
  ) {}

  clone(): Sphere {
    return new Sphere(this.center.clone(), this.radius);
  }
}

export class OctreeGeometry {
  root!: OctreeGeometryNode;

  url: string | null = null;

  pointAttributes: PointAttributes | null = null;

  spacing: number = 0;

  tightBoundingBox: BoundingBox;

  numNodesLoading: number = 0;

  maxNumNodesLoading: number = 3; // I don't understand why this is also a property of IPotree then. Duplicate functionality?

  boundingSphere: Sphere;

  tightBoundingSphere: Sphere;

  offset!: Vector3;

  scale!: [number, number, number];

  disposed: boolean = false;

  projection?: Metadata['projection'];

  constructor(
    public loader: NodeLoader,
    public boundingBox: BoundingBox, // Need to be get from metadata.json
  ) {
    this.tightBoundingBox = boundingBox.clone();
    // バウンディングボックスからバウンディングスフィアを計算
    const center = boundingBox.centerWorld;
    const extent = boundingBox.extendSizeWorld;
    const radius = extent.length() / 2;
    this.boundingSphere = new Sphere(center, radius);
    this.tightBoundingSphere = new Sphere(center, radius);
  }

  dispose(): void {
    // this.loader.dispose();
    this.root.traverse((node) => {
      return node.dispose();
    });
    this.disposed = true;
  }
}
